import { useEffect, useState } from 'react';
import { getCurrentUser, isUserLoggedIn, onAuthChange } from '../../services/AuthService';

const snapshot = () => ({ isAuth: isUserLoggedIn(), user: getCurrentUser() });

/** Reactive auth state: re-renders on login, logout, expired session or changes in another tab. */
export default function useAuth() {
  const [state, setState] = useState(snapshot);

  useEffect(() => {
    const update = () => setState(snapshot());
    const unsubscribe = onAuthChange(update);
    // Re-check when the app comes back to the foreground (token may have expired meanwhile).
    const onVisible = () => { if (document.visibilityState === 'visible') update(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      unsubscribe();
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);

  return state;
}
